"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.show = show;
exports.clientShow = clientShow;
Object.defineProperty(exports, "MobileSiteNavigation", {
  enumerable: true,
  get: function get() {
    return _$previous.MobileSiteNavigation;
  }
});
Object.defineProperty(exports, "AnimatedContainer", {
  enumerable: true,
  get: function get() {
    return _$previous.AnimatedContainer;
  }
});
Object.defineProperty(exports, "showMobile", {
  enumerable: true,
  get: function get() {
    return _$previous.showMobile;
  }
});
exports.ClientSelect = exports.default = void 0;

var _$previous = _interopRequireWildcard(require("$previous"));

var _react = _interopRequireWildcard(require("react"));

var _reactDom = babelHelpers.interopRequireDefault(require("react-dom"));

var _decorators = require("decorators");

var _classList = babelHelpers.interopRequireDefault(require("class-list"));

var _facilitiesModal = babelHelpers.interopRequireDefault(require("modals/facilities-modal"));

var _fetch = babelHelpers.interopRequireDefault(require("fetch"));

var _requestAccess = babelHelpers.interopRequireDefault(require("modals/requestAccess"));

var _SiteLayout = babelHelpers.interopRequireDefault(require("layouts/SiteLayout"));

var _class, _descriptor, _class3, _descriptor2;

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || babelHelpers.typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = babelHelpers.getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = babelHelpers.getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return babelHelpers.possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
} // @babel: { "presets": [ "es2015", "react" ], "plugins": [ "transform-decorators-legacy", "transform-class-properties", "transform-object-rest-spread" ]}


var PrositeSiteNavigation = /*#__PURE__*/function (_DefaultSiteNavigatio) {
  babelHelpers.inherits(PrositeSiteNavigation, _DefaultSiteNavigatio);

  var _super = _createSuper(PrositeSiteNavigation);

  function PrositeSiteNavigation() {
    var _this;

    babelHelpers.classCallCheck(this, PrositeSiteNavigation);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.state = Object.assign(_this.state, {
      client: null
    });
    return _this;
  }

  babelHelpers.createClass(PrositeSiteNavigation, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this,
          _babelHelpers$get;

      PrositeSiteNavigation.currentNav = this;
      (0, _fetch.default)('data/cart/client').then(function (d) {
        return d.json();
      }).then(function (client) {
        return _this2.setState({
          client: client
        });
      });

      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      if (babelHelpers.get(babelHelpers.getPrototypeOf(PrositeSiteNavigation.prototype), "componentDidMount", this)) (_babelHelpers$get = babelHelpers.get(babelHelpers.getPrototypeOf(PrositeSiteNavigation.prototype), "componentDidMount", this)).call.apply(_babelHelpers$get, [this].concat(args));

      if (location.search.startsWith('?access')) {
        setTimeout(function () {
          return _requestAccess.default.show();
        }, 0);
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var _prevState$profile$gu, _prevState$profile, _this$state$profile$g, _this$state$profile;

      if (prevProps.userProfile.id != this.props.userProfile.id) {
        PrositeSiteNavigation.clientUpdated();
      }

      var wasGuest = (_prevState$profile$gu = (_prevState$profile = prevState.profile) === null || _prevState$profile === void 0 ? void 0 : _prevState$profile.guest) !== null && _prevState$profile$gu !== void 0 ? _prevState$profile$gu : true;
      var isGuest = (_this$state$profile$g = (_this$state$profile = this.state.profile) === null || _this$state$profile === void 0 ? void 0 : _this$state$profile.guest) !== null && _this$state$profile$g !== void 0 ? _this$state$profile$g : true;

      if (wasGuest != isGuest && !isGuest) {
        _facilitiesModal.default.show();
      }

      if (babelHelpers.get(babelHelpers.getPrototypeOf(PrositeSiteNavigation.prototype), "componentDidUpdate", this)) babelHelpers.get(babelHelpers.getPrototypeOf(PrositeSiteNavigation.prototype), "componentDidUpdate", this).call(this, prevProps, prevState);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var _babelHelpers$get2;

      if (PrositeSiteNavigation.currentNav == this) PrositeSiteNavigation.currentNav = null;

      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }

      if (babelHelpers.get(babelHelpers.getPrototypeOf(PrositeSiteNavigation.prototype), "componentWillUnmount", this)) (_babelHelpers$get2 = babelHelpers.get(babelHelpers.getPrototypeOf(PrositeSiteNavigation.prototype), "componentWillUnmount", this)).call.apply(_babelHelpers$get2, [this].concat(args));
    }
  }, {
    key: "renderExtraElements",
    value: function renderExtraElements() {
      if (this.state.profile && !this.state.profile.guest) {
        var _this$state$client$ca, _this$state$client, _this$state$client$ca2;

        return /*#__PURE__*/_react.default.createElement(_react.Fragment, null, /*#__PURE__*/_react.default.createElement(ClientSelect, {
          client: this.state.client
        }), ((_this$state$client$ca = (_this$state$client = this.state.client) === null || _this$state$client === void 0 ? void 0 : (_this$state$client$ca2 = _this$state$client.cart) === null || _this$state$client$ca2 === void 0 ? void 0 : _this$state$client$ca2.length) !== null && _this$state$client$ca !== void 0 ? _this$state$client$ca : 0) > 0 && /*#__PURE__*/_react.default.createElement("a", {
          title: "Cart",
          className: "icon search shopping-cart badge",
          href: "orderreview"
        }, /*#__PURE__*/_react.default.createElement("span", {
          class: "material-icons outlined",
          "data-icon": "shopping_cart"
        }), /*#__PURE__*/_react.default.createElement("span", {
          class: "sr-only"
        }, "View Cart")));
      }

      return /*#__PURE__*/_react.default.createElement(_react.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
        className: "button-container"
      }, /*#__PURE__*/_react.default.createElement("a", {
        title: "Request Access",
        className: "sign-in request-access",
        href: "",
        onClick: function onClick(event) {
          _requestAccess.default.show();

          event.preventDefault();
        }
      }, /*#__PURE__*/_react.default.createElement("p", null, "Request Access"))));
      return null;
    }
  }, {
    key: "renderCenterNav",
    value: function renderCenterNav() {
      if (this.state.profile && !this.state.profile.guest) {
        var m = this.props.menuItems.slice();
        var me = m.pop();
        return /*#__PURE__*/_react.default.createElement("div", {
          className: "nav-center"
        }, m.map(function (item, index) {
          return /*#__PURE__*/_react.default.createElement(_react.Fragment, {
            key: index
          }, index == 0 ? null : /*#__PURE__*/_react.default.createElement("span", null, "\xA0\u2022\xA0"), /*#__PURE__*/_react.default.createElement("a", {
            href: item.link
          }, item.title));
        }), me ? /*#__PURE__*/_react.default.createElement(_react.Fragment, null, /*#__PURE__*/_react.default.createElement("span", null, "\xA0|\xA0"), /*#__PURE__*/_react.default.createElement("a", {
          href: me.link
        }, me.title)) : null);
      }

      return null;
    }
  }], [{
    key: "clientUpdated",
    value: function clientUpdated() {
      this.cartUpdated();

      _SiteLayout.default.current.navigate(_SiteLayout.default.current.props.homeLink);
    }
  }, {
    key: "cartUpdated",
    value: function cartUpdated() {
      var _this3 = this;

      if (this.currentNav) {
        (0, _fetch.default)('data/cart/client').then(function (d) {
          return d.json();
        }).then(function (client) {
          return _this3.currentNav.setState({
            client: client
          });
        });
      }
    }
  }]);
  return PrositeSiteNavigation;
}(_$previous.default);

exports.default = PrositeSiteNavigation;
var MaybeLinked = (_class = /*#__PURE__*/function (_Component) {
  babelHelpers.inherits(MaybeLinked, _Component);

  var _super2 = _createSuper(MaybeLinked);

  function MaybeLinked() {
    var _this4;

    babelHelpers.classCallCheck(this, MaybeLinked);

    for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
      args[_key4] = arguments[_key4];
    }

    _this4 = _super2.call.apply(_super2, [this].concat(args));
    babelHelpers.initializerDefineProperty(_this4, "linked", _descriptor, babelHelpers.assertThisInitialized(_this4));
    return _this4;
  }

  babelHelpers.createClass(MaybeLinked, [{
    key: "render",
    value: function render() {
      var x = Object.assign({}, this.props);
      delete x.linked;
      var Type;

      if (this.linked) {
        Type = 'a';
      } else {
        Type = 'div';
        delete x.href;
      }

      return /*#__PURE__*/_react.default.createElement(Type, x);
    }
  }]);
  return MaybeLinked;
}(_react.Component), (_descriptor = babelHelpers.applyDecoratedDescriptor(_class.prototype, "linked", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class);
var ClientSelect = (_class3 = /*#__PURE__*/function (_Component2) {
  babelHelpers.inherits(ClientSelect, _Component2);

  var _super3 = _createSuper(ClientSelect);

  function ClientSelect() {
    var _this5;

    babelHelpers.classCallCheck(this, ClientSelect);

    for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
      args[_key5] = arguments[_key5];
    }

    _this5 = _super3.call.apply(_super3, [this].concat(args));
    babelHelpers.initializerDefineProperty(_this5, "client", _descriptor2, babelHelpers.assertThisInitialized(_this5));
    _this5.state = {
      cart: null,
      logoErr: false
    };
    return _this5;
  }

  babelHelpers.createClass(ClientSelect, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      ClientSelect.current = this;
      this.fetchCart();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (ClientSelect.current == this) ClientSelect.current = null;
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if ((prevProps.client || {
        id: null
      }).id != (this.client || {
        id: null
      }).id) {
        this.fetchCart();
        this.setState({
          logoErr: false
        });
      }
    }
  }, {
    key: "setCart",
    value: function setCart(data) {
      this.setState({
        cart: data
      });
    }
  }, {
    key: "fetchCart",
    value: function fetchCart() {
      var _this6 = this;

      (0, _fetch.default)('data/cart').then(function (d) {
        return d.json();
      }).then(function (contents) {
        return _this6.setCart(contents);
      });
    }
  }, {
    key: "err",
    value: function err() {
      this.setState({
        logoErr: true
      });
    }
  }, {
    key: "render",
    value: function render() {
      if (!this.client) return null;
      var contents = this.state.cart || [];
      var Type = this.client.hasMultiple ? "a" : "div";
      var props = this.client.hasMultiple ? {
        onClick: this.selectClient,
        href: 'javascript:void(0)'
      } : {};
      return /*#__PURE__*/_react.default.createElement(Type, _extends({}, props, {
        className: "facility-btn",
        "data-has-multiple": this.client.hasMultiple
      }), /*#__PURE__*/_react.default.createElement("div", {
        className: "content"
      }, /*#__PURE__*/_react.default.createElement("p", {
        className: "small"
      }, "Ordering for facility:"), /*#__PURE__*/_react.default.createElement("p", null, this.client.name)), this.client.hasMultiple && /*#__PURE__*/_react.default.createElement("span", {
        className: "change-btn"
      }, /*#__PURE__*/_react.default.createElement("i", {
        className: "material-icons"
      }, "keyboard_arrow_down")));
    }
  }, {
    key: "selectClient",
    value: function selectClient() {
      _facilitiesModal.default.show();
    }
  }]);
  return ClientSelect;
}(_react.Component), (_descriptor2 = babelHelpers.applyDecoratedDescriptor(_class3.prototype, "client", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), babelHelpers.applyDecoratedDescriptor(_class3.prototype, "err", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class3.prototype, "err"), _class3.prototype), babelHelpers.applyDecoratedDescriptor(_class3.prototype, "selectClient", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class3.prototype, "selectClient"), _class3.prototype)), _class3);
exports.ClientSelect = ClientSelect;

function show(parent, props) {
  _reactDom.default.render( /*#__PURE__*/_react.default.createElement(PrositeSiteNavigation, props), parent);
}

function clientShow(props) {
  show(document.querySelector('#nav-container'), props);
}